import { LazyTranslationsLoader } from './registerLazyTranslations.types';

/**
 * Namespace → loader, as registered by each module's generated `i18n/index.ts`.
 * Read by the lazy backend, and by an app that renders another app's screens
 * in an i18next instance of its own (the admin's user-research preview).
 */
export const lazyTranslationsRegistry = new Map<
  string,
  LazyTranslationsLoader
>();

const registerLazyTranslations = (
  ns: string,
  loader: LazyTranslationsLoader,
) => {
  if (
    process.env['NODE_ENV'] !== 'production' &&
    lazyTranslationsRegistry.has(ns)
  ) {
    console.warn(
      `i18n: duplicate registerLazyTranslations for namespace "${ns}" — the previous loader will be overwritten.`,
    );
  }

  lazyTranslationsRegistry.set(ns, loader);
};

export default registerLazyTranslations;
